import { fuzzyMatch } from "@/lib/utils";
import { BookingEngine } from "@/services/collection";
import { ARIDataResponse, getARIData } from "@/services/dataanalysismask";
import { Loader2 } from "lucide-react";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const Ari = () => {
  const [aridata, setAridata] = useState<ARIDataResponse>();
  const [loading, setLoading] = useState(true);

  const [filteredTableData, setFilteredTableData] =
    useState<ARIDataResponse["tableData"]>();

  const [bookingEngineFilter, setBookingEngineFilter] =
    useState<BookingEngine>();

  const [onlyHighMissRate, setOnlyHighMissRate] = useState(false);

  const [search, setSearch] = useState("");

  const [actualSearch, setActualSearch] = useState("");

  useEffect(() => {
    fetchARIData();
  }, []);

  const fetchARIData = async () => {
    try {
      const res = await getARIData({});
      setAridata(res);
      setFilteredTableData(
        res.tableData.sort(
          (a, b) =>
            a.bookingEngine.localeCompare(b.bookingEngine) ||
            b.bookingEngineMisses /
              (b.bookingEngineMisses + b.bookingEngineHits) -
              a.bookingEngineMisses /
                (a.bookingEngineMisses + a.bookingEngineHits)
        )
      );
    } catch {
      console.log("ERROR");
    }
    setLoading(false);
  };

  useEffect(() => {
    if (aridata) {
      if (actualSearch !== "") {
        return setFilteredTableData(
          aridata.tableData.filter((data) =>
            fuzzyMatch(actualSearch, data.name)
          )
        );
      }

      let newTData = [...aridata.tableData];
      console.log(bookingEngineFilter);
      if (bookingEngineFilter && bookingEngineFilter !== "none") {
        newTData = newTData.filter(
          (data) => data.bookingEngine === bookingEngineFilter
        );
      }
      if (onlyHighMissRate) {
        newTData = newTData.filter(
          (data) =>
            data.bookingEngineMisses /
              (data.bookingEngineMisses + data.bookingEngineHits) >
            0.3
        );
      }
      setFilteredTableData(newTData);
    }
  }, [bookingEngineFilter, onlyHighMissRate, actualSearch, aridata]);

  useEffect(() => {
    const t = setTimeout(() => {
      setActualSearch(search);
    }, 1000);
    return () => clearTimeout(t);
  }, [search]);

  if (loading) {
    return (
      <div className="flex flex-col justify-center items-center w-full h-full gap-6">
        <p>Sto raccogliendo i dati</p>
        <Loader2 className="mr-2 h-12 w-12 animate-spin" />
      </div>
    );
  }

  if (!aridata) {
    return null;
  }

  return (
    <div className="flex flex-col gap-8 mb-20">
      <div className="grid grid-cols-4 w-fit gap-4">
        <div className="flex flex-col gap-2 p-2 rounded-xl shadow-md border border-gray-100">
          <p>Partner integrati</p>
          <p className="text-xl">
            {((aridata.activeIntegrated / aridata.actives) * 100).toFixed(2)}%
          </p>
        </div>
        <div className="flex flex-col gap-2 p-2 rounded-xl shadow-md border border-gray-100">
          <p>Totali integrati </p>
          <p className="text-xl">
            {((aridata.totIntegrated / aridata.totCollections) * 100).toFixed(
              2
            )}
            %
          </p>
        </div>
        <div className="flex flex-col gap-2 p-2 rounded-xl shadow-md border border-gray-100">
          <p>Tasso di errore </p>
          <p className="text-xl">
            {(
              (aridata.totMisses / (aridata.totMisses + aridata.totHits)) *
              100
            ).toFixed(2)}
            %
          </p>
        </div>
        <div className="flex flex-col gap-2 p-2 rounded-xl shadow-md border border-gray-100">
          <p>Tasso di successo </p>
          <p className="text-xl">
            {(
              (aridata.totHits / (aridata.totMisses + aridata.totHits)) *
              100
            ).toFixed(2)}
            %
          </p>
        </div>
      </div>
      <input
        value={search}
        placeholder="Cerca per nome"
        onChange={(e) => setSearch(e.target.value)}
        className="p-2 border border-gray-200 rounded-xl max-w-[400px]"
      />
      <div className="flex justify-between w-full">
        <select
          className="w-fit border p-2 rounded-xl"
          value={bookingEngineFilter}
          onChange={(e) =>
            setBookingEngineFilter(e.target.value as BookingEngine)
          }
        >
          <option value="none">Filtro Booking Engine</option>
          {aridata.integratedBookingEngines.map((be) => (
            <option value={be}>{be}</option>
          ))}
        </select>
        <div className="flex items-center gap-2">
          <input
            type="checkbox"
            className="cursor-pointer"
            onChange={(e) => setOnlyHighMissRate(e.target.checked)}
            checked={onlyHighMissRate}
          />
          <p>High miss rate</p>
        </div>
      </div>
      <div className="flex flex-col border border-takyon-black">
        <div className="grid grid-cols-4 border-b p-2 bg-takyon-black text-white">
          <p>Nome</p>
          <p>BookingEngine</p>
          <p>Tasso di errore</p>
          <p>Tasso di successo</p>
        </div>
        {filteredTableData?.map((data, i) => (
          <div
            className="grid grid-cols-4 border-b p-2 gap-4 relative"
            style={{
              backgroundColor: i % 2 !== 0 ? "rgb(209 213 219)" : "transparent",
            }}
          >
            <div
              className="absolute w-full h-full pointer-events-none"
              style={{
                backgroundColor:
                  data.bookingEngineMisses /
                    (data.bookingEngineMisses + data.bookingEngineHits) >
                  0.3
                    ? "rgba(255, 0, 0, 0.3)"
                    : "transparent",
              }}
            />
            <Link
              to={`/collection/${data._id}/taks`}
              target="_blank"
              className="truncate text-ellipsis"
            >
              {data.name}
            </Link>
            <p>{data.bookingEngine}</p>
            <p>
              {(
                (data.bookingEngineMisses /
                  (data.bookingEngineMisses + data.bookingEngineHits)) *
                100
              ).toFixed(2)}
              %
            </p>
            <p>
              {(
                (data.bookingEngineHits /
                  (data.bookingEngineMisses + data.bookingEngineHits)) *
                100
              ).toFixed(2)}
              %
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Ari;
